<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">Data Exchange Settings</div>
    </div>
    <div class="col-md-12 well-content">
        @if (successMsg) {
            <div class="alert alert-success">{{ successMsg }}</div>
        }
        @if (errorMsg) {
            <div class="alert alert-danger">{{ errorMsg }}</div>
        }
        <div class="panel panel-default">
            <div class="panel-heading">Settings</div>
            <div class="panel-body">
                <form #frm="ngForm" class="form-horizontal">
                    <div class="form-group">
                        <label for="dataExchangeBaseUrl" class="col-md-3 control-label"
                            >Data Exchange Base URL <span style="color: red">*</span></label
                        >
                        <div class="col-md-9">
                            <input
                                name="dataExchangeBaseUrl"
                                type="text"
                                required
                                maxlength="255"
                                #baseMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="settings.DataExchangeBaseURL" />
                            @if (baseMdl.touched && baseMdl.invalid) {
                                <span class="text-danger">Data Exchange Base URL is required</span>
                            }
                        </div>
                        <div class="col-md-offset-3 col-md-9">
                            <p class="help-block">
                                Base URL must include trailing slash. Example: https://localhost.local/
                            </p>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="dataExchangeKey" class="col-md-3 control-label"
                            >Data Exchange API Key <span style="color: red">*</span></label
                        >
                        <div class="col-md-9">
                            <input
                                name="dataExchangeKey"
                                type="text"
                                required
                                maxlength="255"
                                #keyMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="settings.DataExchangeAPIKey" />
                            @if (keyMdl.touched && keyMdl.invalid) {
                                <span class="text-danger">Data Exchange API Key is required</span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="dataExchangeVersion" class="col-md-3 control-label"
                            >Data Exchange API Version <span style="color: red">*</span></label
                        >
                        <div class="col-md-9">
                            <input
                                name="dataExchangeVersion"
                                type="text"
                                required
                                maxlength="255"
                                #versMdl="ngModel"
                                class="form-control"
                                [(ngModel)]="settings.DataExchangeAPIVersion" />
                            @if (versMdl.touched && versMdl.invalid) {
                                <span class="text-danger">Data Exchange API Version is required</span>
                            }
                        </div>
                        <div class="col-md-offset-3 col-md-9">
                            <p class="help-block">Example: DYNAMICS_DTP_1</p>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="dataExchangeBaseUrl" class="col-md-3 control-label">Dynamics FO Connector</label>
                        <div class="col-md-9">
                            @if (settings !== undefined) {
                                <nz-switch
                                    style="margin-top: 8px"
                                    nzCheckedChildren="On"
                                    nzUnCheckedChildren="Off"
                                    name="foConnector"
                                    [nzLoading]="loading"
                                    [(ngModel)]="settings.FOConnector"></nz-switch>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <button class="btn btn-default" (click)="update(frm)">Save Changes</button>
    </div>
</div>
